// This file was auto-generated by Fern from our API Definition.
export var AgentaConversationItem;
(function (AgentaConversationItem) {
    AgentaConversationItem.Direction = {
        Inbound: "inbound",
        Outbound: "outbound",
    };
})(AgentaConversationItem || (AgentaConversationItem = {}));
